import { action } from '@play-co/replicant';
import createActions, { SyncActionAPI } from './createActions';
import { duration } from 'src/replicant/utils/duration';
import { AssignManualAbTestBeforeEntryFinalArgs } from 'src/replicant/ab/ab.modifiers';

export default createActions({
  /** Replicant onLogin action, ran on every login. */
  onBeforeEntryFinal: action(
    (state, args: AssignManualAbTestBeforeEntryFinalArgs, api) => {
      // Schedule retention D3 and D4 messages
      scheduleRetentionMessages(args, api);
    },
  ),
});

/**
 * Schedule retention messages if available for the user.
 * @param state
 * @param api
 * @returns
 */
function scheduleRetentionMessages(
  args: AssignManualAbTestBeforeEntryFinalArgs,
  api: SyncActionAPI,
) {
  if (!args.isAdult) return;

  api.scheduledActions.schedule.sendRetentionMessage({
    args: {},
    notificationId: 'chatbotRetention-d3',
    delayInMS: duration({ days: 3 }), // 72 hours
  });
}
